import React from 'react';
import { Modal, ModalFooter, ModalHeader } from 'reactstrap';
import CustomButton from '../../../components/customButton';

const DeleteUserModal = ({ isOpen, cancelCb, confirmCb }) => {
  return (
    <Modal size="lg" id="delete-user-modal" isOpen={isOpen} fade={false} centered>
      <ModalHeader>
        Delete User
        <p className="subtitle">Are you sure you want to remove this user from the portal?</p>
      </ModalHeader>

      <ModalFooter>
        <CustomButton title={'Remove'} classes="btn btn-danger" handleClick={confirmCb} />
        <CustomButton title={'Cancel'} classes={'btn btn-secondary'} handleClick={cancelCb} />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteUserModal;
